import React from 'react';
import { Card, Tabs, Typography } from 'antd';
import { CompassOutlined } from '@ant-design/icons';
import EnquiryForm from './EnquiryForm';
import PricingSheetPanel from './PricingSheetPanel';
import SignupQrPanel from './SignupQrPanel';
import { useClientConfig } from '../../common/client/ClientConfigProvider';
import { DEFAULT_SIGNUP_ENQUIRY_TYPES } from '../../model/client/ClientSettings';

const { Title, Paragraph } = Typography;

// Tour operator workspace. Left-hand tabs walk the operator through a tour:
// capture the enquiry, show the pricing sheet, then present the QR code for the
// guest to sign up on their own device.
const TourSignup: React.FC = () => {
    const { signup } = useClientConfig();
    const enquiryTypeOptions = signup?.enquiryTypes ?? DEFAULT_SIGNUP_ENQUIRY_TYPES;
    const tabs = [
        {
            key: 'enquiry',
            label: 'New Enquiry',
            children: (
                <EnquiryForm
                    guestTypeOptions={enquiryTypeOptions}
                    guestTypeLabel="Enquiry Type"
                    submitLabel="Create Enquiry"
                    successMessage="Enquiry captured successfully"
                    testIdPrefix="tour-signup"
                />
            ),
        },
        {
            key: 'pricing',
            label: 'Pricing Sheet',
            children: <PricingSheetPanel />,
        },
        {
            key: 'signup',
            label: 'Sign Up',
            children: <SignupQrPanel />,
        },
    ];

    // Wider than a plain form so the pricing sheet renders large; maxWidth +
    // auto margins keep it within the content column and collapse responsively.
    return (
        <div style={{ maxWidth: 960, margin: '0 auto' }}>
            <Card>
                <div style={{ display: 'flex', alignItems: 'center', marginBottom: 16, gap: 8 }}>
                    <CompassOutlined style={{ fontSize: 24 }} />
                    <Title level={3} style={{ margin: 0 }}>
                        Tour Signup
                    </Title>
                </div>
                <Paragraph type="secondary">
                    Capture a tour or call enquiry, show membership pricing, and let the guest scan to sign up.
                </Paragraph>

                <Tabs
                    tabPosition="left"
                    defaultActiveKey="enquiry"
                    items={tabs}
                />
            </Card>
        </div>
    );
};

export default TourSignup;
